"use strict";
exports.__esModule = true;
exports.socialNetwork = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../../../fields");
var socialNetwork = function (type) { return function (data, logger) {
    var _a;
    if (!data) {
        return undefined;
    }
    return utils_1.compact({
        type: type,
        link: logger.required(fields_1.toWebLink((_a = data.primary) === null || _a === void 0 ? void 0 : _a.link, logger))
    });
}; };
exports.socialNetwork = socialNetwork;
//# sourceMappingURL=footer-social-network.js.map